/**
 * Index centralisé de tous les codes d'erreur API
 * Source unique de vérité pour le mapping entre codes techniques et messages utilisateur
 */

import { ACTION_TYPE_ERRORS } from './action-type.errors';
import { AI_ERRORS } from './ai.errors';
import { AUTH_ERRORS } from './auth.errors';
import { BOOND_ERRORS } from './boond.errors';
import { CONTACT_PERSONS_ERRORS } from './contact-persons.errors';
import { DT_ERRORS } from './dt.errors';
import { GLOBAL_ERRORS } from './global.errors';
import { INTERVIEW_PREPARATION_ERRORS } from './interview-preparation.errors';
import { MISTRAL_ERRORS } from './mistral.errors';
import { OPPORTUNITY_ERRORS } from './opportunity.errors';
import { OUTBOUND_ERRORS } from './outbound.errors';
import { POSITIONING_ERRORS } from './positioning.errors';
import { SHARED_LINK_ERRORS } from './shared-link.errors';
import { SUBSCRIPTION_ERRORS } from './subscription.errors';
import { ErrorConfigWithCallback } from './types';

/**
 * Dictionnaire unifié de tous les codes d'erreur
 */
export const ERROR_DICTIONARY: Record<string, ErrorConfigWithCallback> = {
    ...GLOBAL_ERRORS,
    ...AUTH_ERRORS,
    ...BOOND_ERRORS,
    ...DT_ERRORS,
    ...OPPORTUNITY_ERRORS,
    ...AI_ERRORS,
    ...MISTRAL_ERRORS,
    ...SUBSCRIPTION_ERRORS,
    ...INTERVIEW_PREPARATION_ERRORS,
    ...POSITIONING_ERRORS,
    ...ACTION_TYPE_ERRORS,
    ...SHARED_LINK_ERRORS,
    ...CONTACT_PERSONS_ERRORS,
    ...OUTBOUND_ERRORS,
};

/**
 * Recherche la configuration d'une erreur dans le dictionnaire
 * @param errorCode - Code d'erreur technique retourné par l'API
 * @returns Configuration de l'erreur ou undefined si non trouvée
 */
export const getErrorConfig = (errorCode: string): ErrorConfigWithCallback | undefined => {
    return ERROR_DICTIONARY[errorCode];
};

/**
 * Vérifie si un code d'erreur supports les callbacks personnalisés
 * @param errorCode - Code d'erreur technique
 * @returns true si le code supporte un callback
 */
export const supportsCallback = (errorCode: string): boolean => {
    const config = getErrorConfig(errorCode);
    return config?.callbackable === true;
};

// Export des dictionnaires individuels pour les imports ciblés si nécessaire
export { ACTION_TYPE_ERRORS } from './action-type.errors';
export { AI_ERRORS } from './ai.errors';
export { AUTH_ERRORS } from './auth.errors';
export { BOOND_ERRORS } from './boond.errors';
export { CONTACT_PERSONS_ERRORS } from './contact-persons.errors';
export { DT_ERRORS } from './dt.errors';
export { GLOBAL_ERRORS } from './global.errors';
export { INTERVIEW_PREPARATION_ERRORS } from './interview-preparation.errors';
export { OPPORTUNITY_ERRORS } from './opportunity.errors';
export { OUTBOUND_ERRORS } from './outbound.errors';
export { POSITIONING_ERRORS } from './positioning.errors';
export { SHARED_LINK_ERRORS } from './shared-link.errors';
export { SUBSCRIPTION_ERRORS } from './subscription.errors';
export type { ErrorConfig, ErrorConfigWithCallback, ErrorSeverity } from './types';